// Author: Luis Booth - February 2019
// PK fire!
/*     🧢
**     👦🏻
** 🔥👈🏽👕
*/

import React, { Component } from 'react';
import { Select } from 'react-nice-inputs';
import { VacationContext } from 'js/components/step1/VacationContext';

const revistaEstilo = {
  backgroundColor: '#f2f2f2',
  padding: '1.5rem',
  marginBottom: '1rem',
  marginTop: '1rem',
};

class Children extends Component {

  state = {
    seatType: 'lap',
  };

  // _updateSeatType = (value, name, context) => {
  //   const guestInfo = { ...context.state.guestInfo };

  //   guestInfo[name] = value;

  //   context.setInputValue(value, name);

  //   this.setState({ name: value });
  // }

  _updateAge = (value, name, context, guestIndex) => {

    context.setAge(value, name, guestIndex);
  }

  _generateOptions = () => {

    const options = [];

    for(let x = 2; x <= 15; x++) {
      options.push({
        label: `${x}`,
        value: `${x}`,
      });
    }

    return options;
  }

  render() {

    const { childrenIndex } = this.props;

    const selectOptions = this._generateOptions();

    return (
      <VacationContext.Consumer>
        {(context) => {

          const childrenError = context.state.addGuestErrorDetails[`age_guest_${childrenIndex}_children`];

          let prepopulatedValue = null;

          if(context.state.guestInfo.children) {
            prepopulatedValue = context.state.guestInfo.children[`age_guest_${childrenIndex}`];
          }

          return (
            <div className="row" style={revistaEstilo}>
              <div className="sm-6 children-label">
                Child {childrenIndex + 1} Age <sup>*</sup>
              </div>
              <div className="sm-6">
                <Select name={`age_guest_${childrenIndex}`}
                  classList={ childrenError !== undefined ? ['is-invalid', 'children-wrap'] : ['children-wrap'] }
                  onChange={(value, name) => this._updateAge(value, name, context, childrenIndex)}
                  value={prepopulatedValue}
                  attrs={{ required: true }}
                  defaultText={'Select age'}
                  options={selectOptions}
                />
              </div>
            </div>
          );
        }}
      </VacationContext.Consumer>
    );
  }
}

export default Children;



// WEBPACK FOOTER //
// ./js/components/step1/Children.js